<form #form="ngForm" class="flex flex-col gap-y-8">
	<app-input
		name="title"
		label="Name"
		[(ngModel)]="baseDocx.title"
		required
		[submitted]="form.submitted"
	></app-input>
	<app-dropdown
		[autoSelectLabel]="true"
		[(ngModel)]="baseDocx.type"
		[submitted]="form.submitted"
		[itemGroups]="[{ items: typesList }]"
		name="type"
		label="Type"
		required
	>
	</app-dropdown>

	<ng-container *ngIf="baseDocx.path; else dropzone">
		<div class="flex flex-col gap-y-2">
			<div class="flex justify-end" *ngIf="originalCopy.path">
				<ui-button
					color="secondary"
					style="ghost"
					size="sm"
					label="Download"
					(click)="download(baseDocx.path)"
				></ui-button>
			</div>
			<app-internet-file
				documentName="{{ baseDocx.path | fileNameFromPath }}"
				actionType="upload"
				(onAction)="triggerReUpload()"
			></app-internet-file>
		</div>

		<atomic-dropzone
			class="invisible"
			#fileUploadInput
			size="extra-compact"
			accept=".docx"
			(fileChanged)="onFileChange($event)"
		></atomic-dropzone>
	</ng-container>

	<ng-template #dropzone>
		<atomic-dropzone
			#fileUploadInput
			size="extra-compact"
			accept=".docx"
			(fileChanged)="onFileChange($event)"
		></atomic-dropzone>
	</ng-template>
</form>
